import { CallsTab } from '@/features/leads/components/Detail/Tabs/CallsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/calls')({
  component: CallsTab,
});
